import { useUsersStore } from 'src/stores/users.js'

import { confirmUnfollow } from 'src/services/confirm/confirm.js'

export default {
  props: ['relationship', 'user', 'labelFollowing'],
  data() {
    return {
      inProgress: false,
    }
  },
  computed: {
    isPressed() {
      return this.inProgress || this.relationship.following
    },
    title() {
      if (this.unknown) {
        return this.$t('user_card.relationship_checking')
      } else if (this.inProgress || this.relationship.following) {
        return this.$t('user_card.follow_unfollow')
      } else if (this.relationship.requested) {
        return this.$t('user_card.follow_cancel')
      } else {
        return this.$t('user_card.follow')
      }
    },
    // not asked yet, or the answer is on its way: saying "Follow" here
    // reads as "they unfollowed you"
    unknown() {
      return !!this.relationship.loading
    },
    label() {
      if (this.unknown) {
        return this.$t('user_card.relationship_loading')
      } else if (this.inProgress) {
        return this.$t('user_card.follow_progress')
      } else if (this.relationship.following) {
        return this.labelFollowing || this.$t('user_card.following')
      } else if (this.relationship.requested) {
        return this.$t('user_card.follow_sent')
      } else {
        return this.$t('user_card.follow')
      }
    },
    disabled() {
      return this.unknown || this.inProgress || this.user.deactivated
    },
  },
  methods: {
    onClick() {
      this.relationship.following || this.relationship.requested
        ? this.unfollow()
        : this.follow()
    },
    follow() {
      this.inProgress = true
      useUsersStore()
        .followUser(this.relationship.id)
        .finally(() => {
          this.inProgress = false
        })
    },
    async unfollow() {
      if (!(await confirmUnfollow(this.$t, this.user))) return
      this.inProgress = true
      useUsersStore()
        .unfollowUser(this.relationship.id)
        .finally(() => {
          this.inProgress = false
        })
    },
  },
}
